import { render, staticRenderFns } from "./FileTypeList.vue?vue&type=template&id=05232cbc&scoped=true&"
import script from "./FileTypeList.vue?vue&type=script&lang=js&"
export * from "./FileTypeList.vue?vue&type=script&lang=js&"
import style0 from "./FileTypeList.vue?vue&type=style&index=0&id=05232cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05232cbc",
  null
  
)

export default component.exports